import { Injectable } from '@angular/core';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { CustomerPaymentTermsReq, PaymentTerm, PaymentTermService } from '@cemex-core/cmx-api';
import { combineLatest, Observable, of } from 'rxjs';
import {
  AdtPaymentTermActionTypes,
  FetchAdtJobsitePaymentTermsDetailsAction,
  LoadAdtJobsitePaymentTermDetailAction,
} from '../actions/paymet-terms.action';
import { getLegalEntity, State } from '@cemex/cmx-client-layout';
import { getJobsiteSelected } from '@ordersnproducts/modules/order-builder/reducers';
import { PRODUCT_LINE_ID } from '@ordersnproducts/modules/shared/constants/product-lines-ids';
import { getSelectedProducts } from '../selectors/adt-selectors/products.selector';
/**
 * Effects for adt payment terms
 */
@Injectable()
export class AdtPaymentTermsEffects implements IEffect {
  adtFetchJobsitePaymentTermDetails$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<FetchAdtJobsitePaymentTermsDetailsAction>(AdtPaymentTermActionTypes.FETCH_JOBSITE_PAYMENT_TERM_DETAILS),
      map((action) => action.payload),
      switchMap((paymentTermId) =>
        combineLatest([
          of(paymentTermId),
          this.store.select(getLegalEntity).pipe(filter((data) => !!data)),
          this.store.select(getSelectedProducts).pipe(
            map((data) => data?.[0]?.productId),
            filter((data) => !!data),
            distinctUntilChanged(),
          ),
          this.store.select(getJobsiteSelected).pipe(
            map((selected) => selected?.shipmentLocationId),
            filter((jobsiteId) => !!jobsiteId),
          ),
        ]).pipe(take(1)),
      ),
      switchMap(([paymentTermId, legalEntity, productId, jobsiteId]) => {
        const parameter: CustomerPaymentTermsReq = {
          countryCode: legalEntity.countryCode,
          productLineId: PRODUCT_LINE_ID.ADMIXTURES,
          jobsiteId: jobsiteId,
          customerId: legalEntity.legalEntityTypeCode,
          productId: productId,
        };
        return this.paymentTermService.getCustomerPaymentTermsV2(parameter).pipe(
          map(({ paymentTerms }: { paymentTerms: PaymentTerm[] }) => {
            const paymentTerm = paymentTerms.find((term) => term.paymentTermId === paymentTermId);
            return new LoadAdtJobsitePaymentTermDetailAction(paymentTerm);
          }),
          catchError(() => of(new LoadAdtJobsitePaymentTermDetailAction(null))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private paymentTermService: PaymentTermService,
    private store: Store<State>,
  ) {}
}
